/**
 * @generated SignedSource<<e8278b21b698c49ca4f2ce7c5aa11584>>
 * @relayHash 99e04ae0f602fdf920180a4a20b01f64
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cc30ce118811cae56bcfa1135d7188339be8baea63b88255f6978a2343c97e36

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { BrandingQuery } from './BrandingQuery.graphql';

const node: PreloadableConcreteRequest<BrandingQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "cc30ce118811cae56bcfa1135d7188339be8baea63b88255f6978a2343c97e36",
    "metadata": {},
    "name": "BrandingQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
